SupportOrderView = require('./order_list_element_view')
SupportHelpWizardController = require('../../helpWizardController')
Backbone = require 'backbone'
Backbone.$ = $
SupportOrderListViewTemplate = require('../../../order_list_view.html.mustache')
SupportPurchaseDateTemplate = require('../../../purchase_date.html.mustache')

class SupportV1OrderListView extends Backbone.View
  id: 'orderContent'

  events :
    "click #purchasedDateSortOrders"  : "sortAndRender"
    "click #merchantNameSortOrders" : "sortAndRender"
    "click .orderTableRow"  : "clickingItemsTableRow"
    "click #orderNotListed" : "orderNotListed"
    "click .ordersRowError": "handleErrorLinkClick"

  initialize: (options) ->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportOrderListViewTemplate
    @purchaseDatetemplate = SupportPurchaseDateTemplate
    @currentChosenItemId = 0
    @currentCheckedRadioBtnSel = 0
    @tableId = '#ordersTable'
    @itemView = SupportOrderView
    @currentOrdersFilter = options.currentOrdersFilter
    @setSortParams()

  setSortParams:  ->
    @sortParams = {
      sort_attribute: @currentOrdersFilter.getSortAttribute()
      sort_order: @currentOrdersFilter.getSortOrder()
    }
    if @sortParams.sort_attribute is 'purchased_at'
      @currentSortElementId = 'purchasedDateSortOrders'
    else
      @currentSortElementId =  'merchantNameSortOrders'

    if @sortParams.sort_order is 'descending'
      @isDescSortOrder = true
    else
      @isDescSortOrder = false

  resetSortParams: () ->
    if @isDescSortOrder
      @sortParams.sort_order = 'descending'
    else
      @sortParams.sort_order = 'ascending'
    if @currentSortElementId  is 'purchasedDateSortOrders'
      @sortParams.sort_attribute = 'purchased_at'
    else
      @sortParams.sort_attribute = 'merchant_name'

  setCurrentFilter: () ->
    @resetSortParams()
    filter = Groupon.Support.OrdersCollection.getFilterInstance(@sortParams)
    filter.iterator.resetIterator()
    @currentOrdersFilter = Groupon.Support.currentOrdersFilter = filter
    filter

  render: () ->
    @currentOrdersFilter.iterator.resetIterator()
    hash =
      enableMerchantNameSortOrders : @currentSortElementId is 'purchasedDateSortOrders'
    @$el.html(toHtml @template, hash, @I18nScope)
    _scrollLoad = () =>
      $div = $("#ordersTablewrapper", @$el)
      if ( ($div[0].scrollHeight - $div.scrollTop()) <= ($div.height() + 40) )
        return unless @currentOrdersFilter.iterator.hasNext()
        @renderOrders()
    $("#ordersTablewrapper", @$el).scroll(_.debounce _scrollLoad, 100)
    @renderOrders()
    @delegateEvents()

  renderPurchaseDateView: (dateStr)->
    hash =
      purchasedAt: dateStr
    toHtml @purchaseDatetemplate, hash, @I18nScope

  renderItems: (orders) ->
    if @currentSortElementId == 'purchasedDateSortOrders'
      @renderOrdersGroupedByPurchaseDate(orders)
    else
      @renderOrdersByMerchantName(orders)

  renderOrdersByMerchantName: (items) ->
    return unless items?.length > 0
    itemsTable = @$el.find(@tableId)
    for current in items
      if current
        @renderSingleItem(current, itemsTable)

  renderOrdersGroupedByPurchaseDate: (orders) ->
    return unless orders?.length > 0
    ordersTable = $(@el).find(@tableId)
    for orderData in orders
      lastRow = $("tr.orderTableRow[dateStr=\"#{orderData.purchasedAtshortDatetimeStr}\"]:last-child", @$el)
      if lastRow.length > 0
        itemView = new @itemView
        itemView.renderSingleItem(orderData)
        lastRow.after(itemView.$el)
      else
        ordersTable.append @renderPurchaseDateView(orderData.purchasedAtshortDatetimeStr)
        @renderSingleItem(orderData, ordersTable)

  renderSingleItem: (orderData, $container) ->
    itemView = new @itemView
    itemView.renderSingleItem(orderData)
    $container.append(itemView.$el)

  sortAndRender: (e)->
    currentjQuerySel = $(e.currentTarget)
    if @currentSortElementId == currentjQuerySel.attr('id')
      @isDescSortOrder = !@isDescSortOrder
    else
      @removeDisableClassFromPreviousSortLink()
      @currentSortElementId = currentjQuerySel.attr('id')
      @addDisableClassToSortLink(@currentSortElementId)
      @setDefaultSortOrder()
    @setCurrentFilter()
    $(@el).find(@tableId).empty()
    @renderOrders()

  setDefaultSortOrder: () ->
    if @currentSortElementId is 'purchasedDateSortOrders'
      @isDescSortOrder = true
    else
      @isDescSortOrder = false

  removeDisableClassFromPreviousSortLink: ->
    ele = $('#' + @currentSortElementId)
    ele.removeClass "disabledLink"

  addDisableClassToSortLink: (selectorId)->
    ele = $('#'+selectorId)
    ele.addClass "disabledLink"

  orderNotListed: () ->
    GIG.Modal.close()
    Groupon.Support.ORDER_NOT_LISTED = true
    Groupon.Support.NOT_ORDER_RELATED = false
    SupportHelpWizardController.changeCurrentOrder(null)
    Backbone.history.navigate('#select-issue', {trigger: true})
    return false

  finishChoosingItem:(e)->
    GIG.Modal.close()
    if @currentChosenItemId? and String(Groupon.Support.currentOrder.id) != String @currentChosenItemId
        item = Groupon.Support.OrdersCollection.findOrderById(@currentChosenItemId)
        SupportHelpWizardController.stepOne(item) if item?
    return false

  clickingItemsTableRow: (e) ->
    ele = $(e.currentTarget)
    radioBtn = ele.find('input')
    @currentCheckedRadioBtnSel.prop('checked', false) if @currentCheckedRadioBtnSel != 0
    @currentCheckedRadioBtnSel = radioBtn
    radioBtn.prop('checked', true)
    @currentChosenItemId = ele.attr('key')
    @finishChoosingItem()
    return false

  handleErrorLinkClick: () ->
    @currentOrdersFilter.iterator.resetState()
    @renderOrders()

  renderOrders: () ->
    return unless @currentOrdersFilter.iterator.hasNext()
    @removeOrdersFetchError()
    @renderSpinner()
    successCb = (orders) =>
      @removeSpinner()
      if orders?.length > 0
        @renderItems(orders)
        @checkIfMinimumOrdersAreShown()
      else
        @renderOrders()
    errCb = () =>
      @removeSpinner()
      @renderOrdersFetchError()
    @currentOrdersFilter.iterator.next(successCb, errCb)

  checkIfMinimumOrdersAreShown : () ->
    return unless @currentOrdersFilter.iterator.hasNext()
    if @currentOrdersFilter.iterator.getNumberOfOrdersFetched() < @currentOrdersFilter.iterator.getNumberOfItemPerPage()
      @renderOrders()

  renderOrdersFetchError: () ->
    @removeOrdersFetchError()
    ordersTable = $(@el).find(@tableId)
    ordersTable.append(@errorHtml())

  errorHtml: () ->
    $ordersRowError = $('.template-table tr.ordersRowErrorSample', @$el).clone()
    $ordersRowError.removeClass('ordersRowErrorSample').addClass('ordersRowError')
    $ordersRowError

  removeOrdersFetchError: () ->
    $('.ordersRowError',  @$el).remove()

  renderSpinner: () ->
    @removeSpinner()
    ordersTable = $(@el).find(@tableId)
    ordersTable.append(@spinnerHtml())

  spinnerHtml: () ->
    $div = $("<div></div>")
    showLoading($div, "50px")
    $ordersRowSpinner = $('.template-table tr.ordersRowSpinnerSample', @$el).clone()
    $('.content', $ordersRowSpinner).html($div.html())
    $ordersRowSpinner.removeClass('ordersRowSpinnerSample').addClass('ordersRowSpinner')
    $ordersRowSpinner

  removeSpinner: () ->
    $('.ordersRowSpinner', @$el).remove()

module.exports = SupportV1OrderListView
